app.factory('reportModel', ['$rootScope', '$q', 'baseModel', 'meedy.reportService',
    function($rootScope, $q, baseModel, reportService) {

	    function ReportModel() {
	

            this.downloadReport = function(reportName, startDate, endDate) {
                return reportService.downloadReport(reportName, startDate, endDate).then(
                    function (successResponse) {
                        return successResponse;
                    },
                    function(error) {
                        return $q.reject(error);
                    }
                );
            };

	
	    }
	
	    return new ReportModel();
	}
]);
